<template>
  <div>
    <div
      v-show="!isHideList"
      v-loading="loading"
      class="hotspot-panel"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="hotspot-panel-title">折线列表</div>
      <div v-if="lists.length == 0" class="hotspot-placeholder">暂无折线</div>
      <div v-else class="hotspot-list">
        <div v-for="item in lists" :key="item.id" class="item">
          <div class="title">{{ item.name }}</div>
          <div class="operate v-row">
            <div class="btn" @click="positionHotspot(item)">定位</div>
            <div class="line">|</div>
            <el-popconfirm title="确认删除?" @onConfirm="deleteHotSpot(item)">
              <div slot="reference" v-loading="item.deleteLoading" class="btn">删除</div>
            </el-popconfirm>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="btn v-bg-yellow" @click="startDrawing(1)">
          <i class="iconfont icon-draw-rect"></i>
          <div class="label" style="margin-left: 3px">框选折线</div>
        </div>
        <div class="btn v-bg-blue" @click="startDrawing(2)">
          <i class="iconfont icon-draw-click"></i>
          <div class="label" style="margin-left: 3px">点选折线</div>
        </div>
        <div class="btn v-bg-green" @click="startDrawing(2, true)">
          <i class="iconfont icon-draw-click"></i>
          <div class="label" style="margin-left: 3px">虚线箭头</div>
        </div>
        <div class="btn btn-cancel" @click="closeDialog">取消</div>
      </div>
    </div>
    <polyline-draw
      v-if="isShowPolylineDraw"
      :show.sync="isShowPolylineDraw"
      :hide.sync="isHideList"
      :mode="mode"
      :is-arrow-line="isArrowLine"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import polylineDraw from './page-hedaer-polyline-draw';

export default {
  components: { polylineDraw },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      isShowPolylineDraw: false,
      mode: 1,
      isHideList: false,
      isArrowLine: false,
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'sceneDetail', 'materialId']),
    lists: function() {
      return this.sceneDetail.pointList;
    },
  },

  created() {
    window.krpjs.deletePolyline = this.deletePolyline;
  },

  destroyed() {
    window.krpjs.deletePolyline = null;
  },

  methods: {
    ...mapActions('tour', {
      actionGetSceneDetail: 'getSceneDetail',
    }),

    //开始绘制
    startDrawing(mode, isArrowLine = false) {
      this.mode = mode;
      this.isShowPolylineDraw = true;
      this.isArrowLine = isArrowLine;
      this.krp.set('control.usercontrol', 'off');
      this.isHideList = true;
    },

    closeDialog() {
      this.$emit('update:show', false);
    },

    //删除热点
    async deleteHotSpot(row) {
      try {
        this.$set(row, 'deleteLoading', true);
        await this.api.point.delete({ id: row.id });
        await this.actionGetSceneDetail({ materialId: this.materialId });
        this.krp.call(`removehotspot(polyline_${row.id}))`);
        this.krp.call(`removehotspot(polyline_${row.id}_arrow_0))`);
        this.krp.call(`removehotspot(polyline_${row.id}_arrow_1))`);
        this.$message.success('删除成功');
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },

    //定位热点
    positionHotspot(row) {
      let fov = this.krp.get('view.fov');
      this.krp.call(`lookto(${row.ath},${row.atv},${fov},smooth())`);
    },

    //删除-折线-提交
    async deletePolyline(name, id) {
      try {
        await this.$confirm('确认删除?', '提示', { type: 'warning' });
        await this.api.polyline.delete({ id });
        this.removePolylineComment(name);
        this.$message.success('删除成功');
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hotspot-panel {
  color: #fff;
  position: absolute;
  top: 60px;
  right: 20px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  width: 350px;
}

.hotspot-list {
  padding: 10px;
  min-height: 200px;
}

.hotspot-list .item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  padding: 10px;

  &:hover {
    border-color: #1e9fffcc;
  }
}

.hotspot-list .item .icon-box {
  width: 50px;
}

.hotspot-list .item .icon {
  display: block;
  height: 30px;
  max-width: 100%;
}

.hotspot-list .item .title {
  flex: 1;
  padding: 0 20px 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.hotspot-list .item .operate {
  font-size: 12px;
}

.hotspot-list .item .operate .line {
  margin: 0 3px;
}

.hotspot-list .item .operate .btn {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;

  &:hover {
    font-weight: bold;
  }
}

.hotspot-placeholder {
  padding: 100px;
  text-align: center;
}

.panel-footer {
  display: flex;
}

.panel-footer .btn {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.panel-footer .btn-cancel {
  background: #9e9e9e;
}

.hotspot-panel-title {
  padding: 10px 0;
  margin: 0 10px;
  border-bottom: 1px solid #eee;
}
</style>
